export const API_URL = (process.env.NODE_ENV === "development" && process.env.REACT_APP_DB_ENV)
? "http://localhost:3020/custom" : "https://api.tentenbn.com/custom"
